import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as TheoricalLayerActions from './theorical-layer.actions';
import { TheoricalLayer } from '../../models/theorical-layer';


export interface State extends EntityState<TheoricalLayer> {
  selectedReferenceTheoricalLayerId: string | undefined;
}

export const adapter: EntityAdapter<TheoricalLayer> = createEntityAdapter<TheoricalLayer>();

export const initialState: State = adapter.getInitialState({selectedReferenceTheoricalLayerId: undefined});

const theoricalLayerReducer = createReducer(
  initialState,
  on(TheoricalLayerActions.loadTheoricalLayers, (state) => {
    return state;
  }),
  on(TheoricalLayerActions.loadTheoricalLayersSuccess, (state, { theoricalLayers }) => {
    return adapter.setAll(theoricalLayers, state);
  }),
  on(TheoricalLayerActions.loadTheoricalLayersFailure, (state, { error }) => {
    return state;
  }),
);

export function reducer(state: State | undefined, action: Action): any {
  return theoricalLayerReducer(state, action);
}

export const getSelectedReferenceTheoricalLayerId = (state: State) => state.selectedReferenceTheoricalLayerId;
